import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination w-100" }
const _hoisted_2 = ["onClick"]

import { ref, watch } from "vue";
import { BlockContentsDTO } from '../../../server/dto/BlockContentsDTO';

interface Prop {
  fullRows: any[];
  pageSize: number;
  onPageChanged: (rows: BlockContentsDTO[], index: number) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNation',
  props: {
    fullRows: null,
    pageSize: { default: 10 },
    onPageChanged: { type: Function, default: () => {
    return;
  } }
  },
  setup(__props: any) {

const props = __props as { fullRows: any[], pageSize: number, onPageChanged: (rows: BlockContentsDTO[], index: number) => void };



const currentPage = ref(0);
const rowsInPage = ref([]);

const total = () => {
  return Math.ceil(props.fullRows.length / props.pageSize);
};

const paginations = (): number[] => {
  // 連番配列を取得
  return Array.from({ length: total() }, (v, k) => k);
};

const pageChanged = (index: number) => {
  currentPage.value = index;
  const start = currentPage.value * props.pageSize;
  const end = (currentPage.value + 1) * props.pageSize;
  rowsInPage.value = props.fullRows.slice(start, end);
  props.onPageChanged(rowsInPage.value, currentPage.value);
};

watch(
  () => props.fullRows,
  (first, second) => {
    // console.log('page', first, second);
    pageChanged(0);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginations(), (index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(["page-item", { active: currentPage.value === index }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: ($event: any) => (pageChanged(index))
          }, _toDisplayString(index + 1), 9, _hoisted_2)
        ], 2))
      }), 128))
    ])
  ]))
}
}

})